const styles = {
  spinner: {
    alignSelf: 'center',
    margin: '1em 0',
  },
};

export default styles;
